<routed-modal>
  <dfk-routed-modal
    routes={routes()}
    props={props}
    class="p-print-0"
    riot-instance={riot}
  ><fly-in /></dfk-routed-modal>

  <script>
    import * as riot from 'riot'

    import {util} from '@wendig/lib'

    import DfkRoutedModal from '@dfk-paris/frontend/src/components/routed_modal.riot'

    import RecordViewer from './record_viewer.riot'
    import MapPage from './map_page.riot'
    import Watchlist from './watchlist.riot'

    export default class {
      static components = {
        'dfk-routed-modal': DfkRoutedModal
      }

      constructor() {
        this.riot = riot
      }
      
      routes() {
        return [
          {url: /^$/, component: null},
          {url: /^\/records\/(?<id>\d+)$/, component: RecordViewer},
          {url: /^\/maps\/(?<id>[a-z0-9\-]+)$/, component: MapPage},
          {url: /^\/watchlist$/, component: Watchlist}
        ]
      }

      onMounted() {
        const element = this.root.querySelector('dfk-routed-modal')
        document.querySelector('body').append(element)
      }
    }
  </script>
</routed-modal>
